import Vue from 'vue'
import * as API from '@/endpoints'
import Axios from 'axios'

import Cons from '@/constants.json'

import axiosRetry from 'axios-retry';

axiosRetry(Axios, { retries: 0 });

export default {
  namespaced: true,
  state: {
    videos: {
      data: [],
      next_link: null,
      page: null,
      per_page: 20,
      prev_link: null,
      total: null
    },
    packageStories: [],
    selectedStory: null,
    brand: {},
    userBrands: {
      isLoading: false,
      data: null
    }
  },
  getters: {
    getSelectedStory( state ) { 
      for( let x=0; x<state.packageStories.length; x++) {
        if ( state.selectedStory === state.packageStories[x].id ) {
          return state.packageStories[x];
        }
      }
    },
    getPackageStories(state){
      return state.packageStories
    },
    getUserBrands(state){
      return state.userBrands
    }
  },
  mutations: {
    setSelectedStory(state, v) {
      state.selectedStory = v;
    },
    addToStackStory(state, v) {
      state.packageStories = v;
    },
    pushVideos (state, payload) {
      state.videos.data = payload
    },
    setBrand(state, v){
      state.brand = v
    }
  },
  actions: {
    getBrandByCode({ }, code) {
      return new Promise((resolve, reject) => {
        Axios.get(`${API.endpoints.brandByCode}/${code}`)
          .then(res => resolve(res.data))
          .catch(error => reject(error))
      })
    },
    async getUserBrands({state, commit, dispatch}, payload){
      try {
        state.userBrands.isLoading = true;
        let res = await Axios.get(`${API.endpoints.base}user/${payload}/brands?brand_id=1`)
        
        if (res.status == 200) {
          state.userBrands.data = res.data
        }
      } catch(e) {
        console.log(e)
      } finally {
        state.userBrands.isLoading = false;
      }
    },
    getAppBrand({commit, dispatch}){
      return new Promise((resolve, reject) => {
          Axios.get(API.endpoints.brand + "/" + Cons[0].BRAND_ID, {
            'axios-retry': {
              retries: 3
            }
          })
          .then(res => {
              commit('setBrand', res.data)
              resolve(res.data)
          },
          error => {
              dispatch('exceptionHandling', {_err: error}, {root: 1})
              reject(error)
          })
      })
    },
    getBrandStories({commit, dispatch}, payload) {
      return Axios.get(`${API.endpoints.base}/brand/${payload}/user/stories`)
        .then(res => {
          console.log("GET BRAND STORIES", res.data)
          commit('setSelectedStory', (res.data.length >= 1) ? res.data[0].id : null);
          commit('addToStackStory', res.data);
          return Promise.resolve(res.data);
        })
        .catch(err => { 
          dispatch('exceptionHandling', { _err: err }, { root: 1 })
          return Promise.reject(err);
        })
    },
    getYoutubeVideos ({commit, dispatch, state}, {id}) {
      return Axios.get(API.endpoints.base + 'brand/' + id + '/youtube/videos')
        .then((response) => {
          commit('pushVideos', response.data.data)
          return response
        })
    },
    getYoutubeVideosById ({commit}, {brandId, youtubeId}) {
      return Axios.get(API.endpoints.base + `/brand/${brandId}/video/${youtubeId}`)
    },
    getBrandVideos ({commit}) {
      return Axios.get(API.endpoints.base + '/careplan/' + Cons[0].GROUP_ID.brandVideos + '/item?sort_by=rrule_parsed_date&asc=0')
        .then((response) => {
          commit('pushVideos', response.data.careplan_item)
        })
    }
  }
}